import React from "react";
import userService from "../services/userService";
import auth from "../services/authService";
import Form from "../components/common/form";
import { fieldValidator } from "../components/common/fieldValidator";
import { toast } from "react-toastify";
import { Typography, Button } from '@material-ui/core';

export class Profile extends Form {
  state = {
    data: { 
      email: "", 
      name: "",
      invoice_name: "",
      invoice_city: "",
      invoice_zip: "",
      invoice_address: "",
      invoice_taxcode: "",
      invoice_email: "",
      password: "", 
      password_confirm: "",
      change_password: false,
    },
    errors: {}
  };

  componentDidMount = () => {
    this.loadData()
  }

  loadData = async () => {
    let data = { ...this.state.data};
    const userData = (await userService.getUserProfile()).data.user;
    data.email = String(userData['Email']);
    data.name = String(userData['Name']);
    data.invoice_name = String(userData['InvoiceName']);
    data.invoice_city = String(userData['InvoiceCity']);
    data.invoice_zip = String(userData['InvoiceZip']);
    data.invoice_address = String(userData['InvoiceAddress']);
    data.invoice_taxcode = String(userData['InvoiceTaxCode']);
    data.invoice_email = String(userData['InvoiceEmail']);
    this.setState({ data })
  }

  componentDidUpdate(prevProps, prevState) {
    const passwordStateChanged =
      prevState.data.change_password !== this.state.data.change_password ||
      prevState.data.password !== this.state.data.password ||
      prevState.data.password_confirm !== this.state.data.password_confirm;

    if (!passwordStateChanged) {
      return;
    }

    const passwordErrors = this.getPasswordErrors();
    const nextErrors = {
      ...this.state.errors,
      password: passwordErrors.password,
      password_confirm: passwordErrors.password_confirm,
    };

    if (
      nextErrors.password !== this.state.errors.password ||
      nextErrors.password_confirm !== this.state.errors.password_confirm
    ) {
      this.setState({ errors: nextErrors });
    }
  }

  getPasswordErrors = () => {
    const { change_password, password, password_confirm } = this.state.data;

    if (!change_password) {
      return {
        password: null,
        password_confirm: null,
      };
    }

    return {
      password: fieldValidator("password", password),
      password_confirm:
        password !== password_confirm ? "Nem egyezik" : fieldValidator("password_confirm", password_confirm),
    };
  };

  hasClientValidationErrors = () => {
    const passwordErrors = this.getPasswordErrors();
    return Object.values({
      ...this.state.errors,
      ...passwordErrors,
    }).some(Boolean);
  };

  doSubmit = async () => {
    const passwordErrors = this.getPasswordErrors();
    const errors = {
      ...this.state.errors,
      ...passwordErrors,
    };

    if (Object.values(errors).some(Boolean)) {
      this.setState({ errors });
      return;
    }

    this.setState({ errors: {} })

    try {
      await userService.update(this.state.data);
      toast.success("Sikeres mentés!");
      this.setState((prevState) => ({
        data: {
          ...prevState.data,
          password: "",
          password_confirm: "",
          change_password: false,
        },
        errors: {},
      }));
    } catch (ex) {
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        errors.email = ex.response.data.errors['Email'] || "";
        errors.name = ex.response.data.errors['Name'] || "";
        errors.password = ex.response.data.errors['Password'] || "";
        this.setState({ errors: errors });
      }
    }
  };

  changePasswordFields = () => {
    return (
      <div>
        {this.renderInput("password", "Jelszó", "password")}
        {this.renderInput("password_confirm", "Jelszó megerősítés", "password")}
      </div>
    )
  }

  handleProfileDelete = async () => {
    let answer = prompt("Ha biztosan törölni szeretnéd a profiladat ird be az alábbi mezőbe a 'törlés' szót!")
    if(answer === 'törlés') {
      await userService.deleteUserProfile()
      await auth.logout()
      window.location = "/"
    }
  }

  render() {
    const isDisabled = this.hasClientValidationErrors();

    return (
      <div>
        <h1>Profilom</h1>
        <form onSubmit={this.handleSubmit}>
          {this.renderInput("name", "Név")}
          {this.renderInput("email", "E-mail")}
          {this.renderInput("invoice_name", "Számlázási név")}
          {this.renderInput("invoice_zip", "Számlázási irányítószám")}
          {this.renderInput("invoice_city", "Számlázási város")}
          {this.renderInput("invoice_address", "Számlázási utca, hsz.")}
          {this.renderInput("invoice_taxcode", "Adószám")}
          {this.renderInput("invoice_email", "Elektronikus számlázási e-mail")}
          {this.renderCheckbox("change_password", "Jelszó változtatás")}

          {this.state.data.change_password ? this.changePasswordFields() : false }
                
          <br />
          {this.renderButton("Mentés", isDisabled)}
        </form>
        <Typography variant="h6" color="error" style={{marginTop: '30px'}}>Profilom törlése</Typography>
        
        <Button onClick={this.handleProfileDelete} variant="contained" color="secondary" style={{marginTop: '10px'}}>Profilom törlése</Button>
      </div>
    );
  }
}

export default Profile;
